
import { fork, take, call, put } from 'redux-saga/effects'

import * as types from '../types'
import * as actions from '../actions'

import { listCountDetails } from '@/network'
import Toast from '@/components/comToast'
export function* costReq() {
    while (true) {
        const { data } = yield take(types.COST_REQ);
        const { channelCode, taskCode, pageNo } = data;
        
        try {
            const info = yield call(listCountDetails, { channelCode, taskCode, pageBean: { pageNo, pageSize: 10 }})
            if (info?.value) {
                yield put(actions.costHandle({list: info.value, pageBean: info.pageBean}));
            } else {
                //yield put(actions.receiveConsumeRecord(pageNum, []))
            }
        } catch (e) {
            if(e?.error) {
                Toast.showMessage('活动太火爆了');
            }
        } finally {
        }

    }
}


export default function* root() {
    yield fork(costReq)
}